import React from 'react';
import { toast } from 'react-toastify';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state to display fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to an error reporting service
    console.error('Uncaught error:', error, errorInfo);
    toast.error('Something went wrong. Please try again later.');

    // Optionally send error details to an external service
    // logErrorToService(error, errorInfo);
  }

  // Optional: Reset error boundary when user tries again
  resetErrorBoundary = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      return (
        <div className="error-boundary-fallback">
          <h2>Oops! Something went wrong.</h2>
          <p>We're sorry for the inconvenience. Please try refreshing the page or come back later.</p>
          <button onClick={() => window.location.reload()}>Reload Page</button>
          {/* Optional: Provide a way to reset the error boundary */}
          {/* <button onClick={this.resetErrorBoundary}>Try Again</button> */}
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
